import { useCallback, useEffect, useRef } from 'react';

export function useChatScroll(messagesLength: number, contentSignal?: number) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const isAtBottomRef = useRef(true);

  const scrollToBottom = useCallback((smooth = true) => {
    scrollRef.current?.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: smooth ? 'smooth' : ('instant' as ScrollBehavior),
    });
  }, []);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return;
    const threshold = 50;
    isAtBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < threshold;
  }, []);

  const forceScrollToBottom = useCallback(
    (smooth = true) => {
      isAtBottomRef.current = true;
      scrollToBottom(smooth);
    },
    [scrollToBottom],
  );

  useEffect(() => {
    if (isAtBottomRef.current) {
      scrollToBottom(true);
    }
  }, [messagesLength, scrollToBottom]);

  useEffect(() => {
    if (isAtBottomRef.current) {
      scrollToBottom(false);
    }
  }, [contentSignal, scrollToBottom]);

  return { scrollRef, handleScroll, forceScrollToBottom };
}
